// hooks/useAddressManagement.ts
import { useState, useCallback } from 'react'
import { FullAddress } from '../../../../common/types/types'
import { getApi } from '../../../../api/api'

export const useAddressManagement = () => {
  const [addresses, setAddresses] = useState<FullAddress[]>([])
  const [selectedAddressId, setSelectedAddressId] = useState<number | null>(null)
  const [api] = useState(getApi())

  const loadAddresses = useCallback(async () => {
    try {
      const result = await api.getAddressList()
      if (result) {
        setAddresses(result)
        // Если есть общий адрес и нет выбранного - выбираем его
        const generalAddress = result.find((addr) => addr.isGeneral)
        if (generalAddress && !selectedAddressId) {
          setSelectedAddressId(Number(generalAddress.id))
        }
      }
    } catch (error) {
      console.error('Error loading addresses:', error)
    }
  }, [api, selectedAddressId])

  const selectedAddress = selectedAddressId
    ? addresses.find((addr) => addr.id === selectedAddressId)
    : null

  return {
    addresses,
    selectedAddressId,
    setSelectedAddressId,
    selectedAddress,
    loadAddresses,
  }
}
